if(!customElements.get('blog-header')) {
  class BlogHeader extends HTMLElement {
    constructor() {
      super();
      this.bindOnMouseDown = this.onMouseDown.bind(this);
      this.bindOnMouseMove = this.onMouseMove.bind(this);
      this.bindOnMouseUp = this.onMouseUp.bind(this);
      this.isDragging = false;
      this.startX = 0;
      this.initScrollLeft = 0;
    }

    connectedCallback() {
      this.categories = this.querySelectorAll('.main-blog__header__categories__item');
      this.categoriesWrapper = this.querySelector('.main-blog__header__categories');

      if (this.classList.contains('main-blog__header--swipe-desktop') || this.classList.contains('main-blog__header--swipe-mobile')) {
        this.checkOverflow();
        this.scrollToActiveCategory();

        this.resizeObserver = new ResizeObserver(() => {
          this.checkOverflow();
        });
        this.resizeObserver.observe(this.categoriesWrapper);
      }
    }

    scrollToActiveCategory() {
      if (!this.categoriesWrapper) return;

      const activeCategory = this.querySelector('.main-blog__header__categories__item.active');
      if (!activeCategory) return;

      const categoriesArray = Array.from(this.categories);
      const activeIndex = categoriesArray.indexOf(activeCategory);
      const isFirst = activeIndex === 0;
      const isLast = activeIndex === categoriesArray.length - 1;

      const computedStyle = window.getComputedStyle(this.categoriesWrapper);
      const gap = parseFloat(computePixelValue(computedStyle.columnGap)) || parseFloat(computePixelValue(computedStyle.gap)) || 0;

      let scrollPosition;

      if (isFirst) {
        scrollPosition = 0;
      } else if (isLast) {
        scrollPosition = this.categoriesWrapper.scrollWidth - this.categoriesWrapper.offsetWidth;
      } else {
        const wrapperRect = this.categoriesWrapper.getBoundingClientRect();
        const activeRect = activeCategory.getBoundingClientRect();
        const peekAmount = 30;

        const activeOffsetFromWrapper = activeRect.left - wrapperRect.left + this.categoriesWrapper.scrollLeft;
        scrollPosition = activeOffsetFromWrapper - peekAmount - gap;
      }

      this.categoriesWrapper.scrollLeft = Math.max(0, scrollPosition);
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.categoriesWrapper) {
        this.categoriesWrapper.removeEventListener('mousedown', this.bindOnMouseDown);
      }
    }

    checkOverflow() {
      if (!this.categoriesWrapper || this.categories.length === 0) return;
      if (window.innerWidth < 750 && !this.classList.contains('main-blog__header--swipe-mobile')) {
        this.categoriesWrapper.classList.remove('overflowed');
        return;
      }
      if (window.innerWidth >= 750 && !this.classList.contains('main-blog__header--swipe-desktop')) {
        this.categoriesWrapper.classList.remove('overflowed');
        return;
      }

      const containerWidth = this.categoriesWrapper.offsetWidth;
      const computedStyle = window.getComputedStyle(this.categoriesWrapper);
      const gap = parseFloat(computePixelValue(computedStyle.columnGap)) || parseFloat(computePixelValue(computedStyle.gap)) || 0;
      const paddingLeft = parseFloat(computePixelValue(computedStyle.paddingLeft)) || parseFloat(computePixelValue(computedStyle.paddingInline)) || parseFloat(computePixelValue(computedStyle.padding)) || 0;
      const paddingRight = parseFloat(computePixelValue(computedStyle.paddingRight)) || parseFloat(computePixelValue(computedStyle.paddingInline)) || parseFloat(computePixelValue(computedStyle.padding)) || 0;

      let totalCategoriesWidth = 0;
      this.categories.forEach((category) => {
        totalCategoriesWidth += category.offsetWidth;
      });

      const totalGapsWidth = gap * (this.categories.length - 1);
      const totalContentWidth = totalCategoriesWidth + totalGapsWidth + paddingLeft + paddingRight;

      const isOverflowed = totalContentWidth > containerWidth;
      const wasOverflowed = this.categoriesWrapper.classList.contains('overflowed');

      if (isOverflowed && !wasOverflowed) {
        this.categoriesWrapper.classList.add('overflowed');
        this.categoriesWrapper.addEventListener('mousedown', this.bindOnMouseDown);
      } else if (!isOverflowed && wasOverflowed) {
        this.categoriesWrapper.classList.remove('overflowed');
        this.categoriesWrapper.removeEventListener('mousedown', this.bindOnMouseDown);
      }
    }

    onMouseDown(event) {
      this.isDragging = true;
      this.startX = event.pageX - this.categoriesWrapper.offsetLeft;
      this.initScrollLeft = this.categoriesWrapper.scrollLeft;
      this.categoriesWrapper.classList.add('grabbing');

      this.categoriesWrapper.addEventListener('mousemove', this.bindOnMouseMove);
      this.categoriesWrapper.addEventListener('mouseup', this.bindOnMouseUp);
      this.categoriesWrapper.addEventListener('mouseleave', this.bindOnMouseUp);
    }

    onMouseMove(event) {
      if (!this.isDragging) return;
      event.preventDefault();
      this.categoriesWrapper.classList.add('moving');
      const x = event.pageX - this.categoriesWrapper.offsetLeft;
      const walk = x - this.startX;
      this.categoriesWrapper.scrollLeft = this.initScrollLeft - walk;
    }

    onMouseUp() {
      this.isDragging = false;
      this.categoriesWrapper.classList.remove('grabbing', 'moving');
      this.categoriesWrapper.removeEventListener('mousemove', this.bindOnMouseMove);
      this.categoriesWrapper.removeEventListener('mouseup', this.bindOnMouseUp);
      this.categoriesWrapper.removeEventListener('mouseleave', this.bindOnMouseUp);
    }
  }

  customElements.define('blog-header', BlogHeader);
}